import translate from './autocopmlete-wizard-search.language';

class AutocompleteWizardSearchController {

	constructor($timeout, $document) {
		this.$timeout = $timeout;
		this.$document = $document;
		this.translate =translate;
	}

	$onInit() {
		this.groupListCarrierAndPlan();
		this.filteredPlanList = [];
		this.selectedPlan = null;
		this.selectedCarrier = null;
		this.activeList = 'carrier';

		this.inputFocus = false;
		this.setShowInput(true);
	}

	/*
     * Grouping lists
     */
	groupListCarrierAndPlan() {
		let carrierList = this.carrierList.map( carrier => {
			carrier['groupBy'] = carrier.name[0].toUpperCase();
			return carrier;
		});
		carrierList.splice(0, 0, {
			rank: 0,
			id: "latter",
			name: "I'll choose my insurance later",
			groupBy: ' '
		});
		carrierList.splice(0, 0, {
			rank: 0,
			id: "myself",
			name: "I'm paying for myself",
			groupBy: ' '
		});
		this.carrierList = carrierList;

		let planList = this.planList.map( plan => {
			plan['groupBy'] = plan.name[0].toUpperCase();
			return plan;
		});
		this.planList = planList;
	}

	/*
     * Change value of activeList var to show carrier list or plan list.
     */
	switchList(active) {
		this.searchTextCarrier = "";
		this.searchTextPlan = "";
		if (active === 'carrier' || (active === 'plan' && this.selectedCarrier)) {
			this.activeList = active;
		}
	}

	/*
     * Change selected carrier
     */
	setSelectedCarrier({value}) {
		this.selectedCarrier = value;
		this.searchTextCarrier = this.selectedCarrier.name;
		if (value.id === 'myself' || value.id === 'latter') {
			this.setShowInput(true);
			this.onSelectCallBack(this.selectedCarrier);
		}
		else {
			this.filterPlanListBySelectedCarrier();
			this.activeList = "plan";
			this.searchTextPlan = "";
		}
		this.onDivWizardAreaClick();
	}

	/*
     * Change selected plan
     */
	setSelectedPlan({value}) {
		this.selectedPlan = value;
		this.searchTextPlan = this.selectedPlan.name;
		this.setShowInput(true);
		this.activeList = "carrier";
		this.searchTextCarrier = "";
		this.onSelectCallBack(this.selectedPlan);
	}

	/*
     *  Filter plan list by carrier id.
     */
	filterPlanListBySelectedCarrier() {
		this.filteredPlanList = this.planList.filter(element => {
			return (this.selectedCarrier && element.carrierid === this.selectedCarrier.id);
		});
	}

	setShowInput(value) {
		this.showInput = value
	}

	onInputFocus() {
		this.searchTextCarrier = "";
		this.setShowInput(false);
		this.onDivWizardAreaClick();
	}

	resetCarrierAndPlan() {
		//this.setShowInput(true);
		this.searchTextCarrier = "";
		this.searchTextPlan = "";
		this.selectedCarrier = null;
		this.selectedPlan = null;
	}

	focusCarrierPlanAutoComplete() {
		this.inputFocus = true;
		this.setShowInput(false);
	}


	blurCarrierPlanAutoComplete() {
		if (!this.showInput) {
			let _this = this;
			this.$timeout(function () {
				if (!_this.inputFocus)
					_this.setShowInput(true);
			}, 100);
		}
		this.inputFocus = false;
	}

	onDivWizardAreaClick() {
		this.$timeout(() => {
			$(`#autocomplete-ex-container-${this.activeList} input`).focus();
		});
	}

	onSelectCallBack(value) {
		if (angular.isFunction(this.onSelect))
			this.onSelect({
				$event: {
					value
				}
			});
	}
}

export default AutocompleteWizardSearchController;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/autocomplete-wizard-search/autocomplete-wizard-search.controller.js